var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style-Guides",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Guide",
    transform: "translate(-69.000000, -874.000000)",
    fill: "#858199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(66.000000, 199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/pencil",
    transform: "translate(0.000000, 672.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5041603,7.99326509 L18.8833927,9.6140327 C18.7181518,9.77927365 18.4509536,9.77927365 18.2857127,9.6140327 L14.3832136,5.71153367 C14.2179727,5.54629272 14.2179727,5.27909459 14.3832136,5.11385364 L16.0039813,3.49308603 C16.6614293,2.83563799 17.7302218,2.83563799 18.3911856,3.49308603 L20.5041603,5.60606073 C21.1651241,6.26350876 21.1651241,7.33230129 20.5041603,7.99326509 Z M12.9909708,6.50609654 L3.75857215,15.7384951 L3.01322999,20.0101495 C2.91127281,20.5867349 3.41402719,21.0859735 3.99061263,20.9875321 L8.26226697,20.2386742 L17.4946656,11.0062756 C17.6599065,10.8410346 17.6599065,10.5738365 17.4946656,10.4085956 L13.5921665,6.50609654 C13.4234098,6.34085559 13.1562117,6.34085559 12.9909708,6.50609654 Z M7.36223116,14.947448 C7.16886409,14.754081 7.16886409,14.4446937 7.36223116,14.2513266 L12.7765091,8.83704866 C12.9698762,8.64368159 13.2792635,8.64368159 13.4726305,8.83704866 C13.6659976,9.03041573 13.6659976,9.33980304 13.4726305,9.53317011 L8.05835261,14.947448 C7.86498554,15.1408151 7.55559823,15.1408151 7.36223116,14.947448 Z M6.09304004,17.9042063 L7.78060718,17.9042063 L7.78060718,19.180429 L5.51293883,19.5777104 L4.41953595,18.4843075 L4.81681738,16.2166392 L6.09304004,16.2166392 L6.09304004,17.9042063 Z",
    id: "Mask"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/iconPencil.c1762109.svg";
export { ForwardRef as ReactComponent };